export default function Divider() {
  return <div className="border-b border-theme-zinc-200" />;
}
